module.exports = __webpack_public_path__ + "static/media/Necchi - Orange - White_Blue.fa57eaa8.jpg";